// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_h0-0";
export var fulfillmentPanelBody = "_h0-1";